import { Dispatch, SetStateAction, useState } from 'react'
import { TAutocompleteValue } from '../types'

type TAutocompleteStateReturn = [TAutocompleteValue, Dispatch<SetStateAction<TAutocompleteValue>>]

/**
 * Manages only typed state for <AutocompleteBase />
 */
export const useAutocompleteState = (
  defaultValue: TAutocompleteValue = null
): TAutocompleteStateReturn => {
  return useState<TAutocompleteValue>(defaultValue)
}
